export const CompetitionTypes = Object.freeze({
    SINGLE_ELIMINATION: 1,
    DOUBLE_ELIMINATION: 2,
    MULTILEVEL: 3,
    STRAIGHT_ROUND_ROBIN: 4,
    ROUND_ROBIN_DOUBLE_SPLIT: 5,
    ROUND_ROBIN_TRIPLE_SPLIT: 6,
    ROUND_ROBIN_QUADRUPLE_SPLIT: 7,
    SEMI_ROUND_ROBINS: 8,
    EXTENDED: 9,
});